import React from 'react';

const tabStyle = (isActive) => ({
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 4,
    paddingBottom: 4,
    background: isActive ? 'rgba(203, 243, 210, 0.30)' : '#F3F3F3',
    borderBottom: isActive ? '3px #006969 solid' : '0.50px #B9B9B9 solid',
    cursor: 'pointer'
});

/**
 * Reusable tab bar.
 *
 * @param {Array<{key: string, label: string}>} tabs - tabs to render
 * @param {string} activeTab - key of the currently active tab
 * @param {(key: string) => void} onTabChange - called with the tab key when a tab is clicked
 * @param {object} [containerStyle] - optional style overrides for the outer container
 * @param {string} [justifyContent] - flex justification for the tab row
 */
const TabNavigation = ({ tabs = [], activeTab, onTabChange, containerStyle, justifyContent = 'flex-start' }) => {
    return (
        <div style={{ width: '100%', borderBottom: '0.50px #B9B9B9 solid', ...containerStyle }}>
            <div style={{ height: 32, display: 'flex', justifyContent }}>
                <div style={{ display: 'flex' }}>
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.key;
                        return (
                            <div
                                key={tab.key}
                                style={tabStyle(isActive)}
                                onClick={() => onTabChange(tab.key)}
                            >
                                <span style={{
                                    color: isActive ? 'black' : '#373737',
                                    fontSize: 16,
                                    fontFamily: 'Roboto',
                                    fontWeight: '400',
                                    lineHeight: '24px',
                                    letterSpacing: 0.04
                                }}>{tab.label}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TabNavigation;
